/* Marketing site URL. VITE_WEBSITE_URL is inlined at build time (dev fallback: ciaotutor.com). */
const WEBSITE_URL = (import.meta.env.VITE_WEBSITE_URL || "https://ciaotutor.com").replace(/\/$/, "");

export function websiteUrl(path = "") {
  return `${WEBSITE_URL}${path}`;
}
